import { Button, Drawer, notification } from 'antd';
import { addedDiff } from 'deep-object-diff';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { respondToParticpantInviteRequest } from '../../controller/client/PartyClient';
import { IParticipantInvite } from '../../PartyClientRequests';
import {
  // IParticipantInvite,
  IPartyForUser,
  TParticipantInviteForUserMap,
  TParticipantInviteId,
} from '../../PartyClientResponse';
import { getIdToken } from '../../controller/PartyDB';
import { AppMapProps, IAppState } from '../../redux/reducer';
import { useAppState } from '../../state/AppState';
import { getAreaInfo } from '../../controller/Areas';

function Notifications({ party, invites }: { party: IPartyForUser } & IAppState) {
  const { user } = useAppState();
  const [isOpen, toggleOpen] = useState(false);

  const incomingInvites = invites;
  const [currentInvites, setCurrentInvites] = useState<TParticipantInviteForUserMap>({});

  useEffect(() => {
    const diff = addedDiff(currentInvites, incomingInvites);
    const newInvites: [string, IParticipantInvite][] = Object.entries(diff);

    if (newInvites.length) {
      setCurrentInvites(incomingInvites);
      newInvites
        .filter(([key, invite]) => invite.state === 'invited')
        .forEach(
          ([key, invite]) => {
            const area = getAreaInfo(invite.area, party);
            const acceptInvite = async () => {
              respondToParticpantInviteRequest({
                inviteId: key as TParticipantInviteId,
                invite,
                idToken: await getIdToken(),
                answer: 'accepted',
              });
              notification.close(key);
            };
            const declineInvite = async () => {
              respondToParticpantInviteRequest({
                inviteId: key as TParticipantInviteId,
                invite,
                idToken: await getIdToken(),
                answer: 'declined',
              });
              notification.close(key);
            };
            notification.open({
              key,
              message: `${invite.inviterName} has invited to ${area.name || area.title}`,
              duration: 0,
              description: (
                <div>
                  <Button style={{ marginRight: 16, color: 'black' }} onClick={acceptInvite}>
                    Accept
                  </Button>
                  <Button type='dashed' style={{ color: 'black' }} onClick={declineInvite}>
                    Decline
                  </Button>
                </div>
              ),
            });
          },
          [incomingInvites]
        );
    }
  }, [setCurrentInvites, currentInvites, incomingInvites, party.key, user, party]);

  return (
    <div>
      {/* <Button onClick={toggleDrawer(anchor, true)}>{anchor}</Button> */}
      <Drawer placement='right' visible={isOpen} onClose={() => toggleOpen(false)}>
        {Object.values(currentInvites).map((invite, index) => (
          <div key={index}>{invite.area}</div>
        ))}
      </Drawer>
    </div>
  );
}

export default connect(AppMapProps)(Notifications);
